import { jsx as r } from "react/jsx-runtime";
import { useRef as t } from "react";
import { classes as c } from "../utils/component.es.js";
import i from "./FadeTransition.es.js";
import s from "../node_modules/react-spinners/esm/PulseLoader.es.js";
function p({
  show: n,
  indicatorColor: o = "#fff",
  loadingStyle: e = "default"
  /* Default */
}) {
  const l = t(null);
  return /* @__PURE__ */ r(
    i,
    {
      in: n,
      unmountOnExit: !0,
      nodeRef: l,
      children: /* @__PURE__ */ r(
        "div",
        {
          ref: l,
          className: c(
            "rcl--absolute rcl--inset-0 rcl--z-10 rcl--flex rcl--size-full rcl--touch-none rcl--place-content-center rcl--items-center",
            e !== "indicatorOnly" && "rcl--backdrop-blur-sm"
          ),
          children: e !== "blurOnly" && /* @__PURE__ */ r(
            s,
            {
              loading: !0,
              className: "rcl--inline-block",
              "data-testid": "m-spinner",
              color: o,
              size: 9
            }
          )
        }
      )
    }
  );
}
export {
  p as default
};
//# sourceMappingURL=LoadingOverlay.es.js.map
